import { env } from '@cc-shopping/platform-env';

export const HOME_PAGE_URL = env.NEXT_PUBLIC_NW_URL;

export const BREADCRUMB_PAGE_PREFIX_MAPPER = {
  ROUNDUPS: 'credit-cards/best',
  REVIEWS: 'credit-cards/reviews',
  COMPARE: 'credit-cards/compare',
} as const;

export type BreadcrumbSource = keyof typeof BREADCRUMB_PAGE_PREFIX_MAPPER;

export const chevronSize = '0.75rem';

export type BreadcrumbData = { label: string; title: string; linkTitle: string; link: string };

export const CREDIT_CARDS_HUB: BreadcrumbData = {
  label: 'CREDIT CARDS',
  title: 'Credit Cards',
  linkTitle: 'Credit Cards Hub',
  link: 'credit-cards',
};

export const BEST_CREDIT_CARDS_HUB: BreadcrumbData = {
  label: 'BEST',
  title: 'Best Credit Cards',
  linkTitle: 'Best Credit Cards',
  link: 'credit-cards/best',
};

export const CREDIT_CARDS_REVIEWS_HUB: BreadcrumbData = {
  label: 'REVIEWS',
  title: 'Credit Cards Reviews',
  linkTitle: 'Credit Cards Reviews',
  link: 'credit-cards/reviews',
};
